import * as constants from './constants'

const mergeTwoEntities = (a, b) => ({
    ...a,
    ...Object.keys(b).reduce(
        (result, key) => {
            result[key] = {
                ...(a[key] || {}),
                ...b[key],
            }

            return result
        },
        { ...a }
    ),
})

export const entities = (state = {}, action) => {
    if (action.type === constants.CLEAR_ENTITY)
        return {
            ...state,
            [action.entity]: undefined,
        }
    else if (action.hasOwnProperty('result') && action.hasOwnProperty('entities')) {
        const { entities } = action

        return Object.keys(entities).reduce(
            (mergedEntities, entity) => {
                mergedEntities[entity] = mergeTwoEntities(mergedEntities[entity] || {}, entities[entity])

                return mergedEntities
            },
            { ...state }
        )
    }

    return state
}
